"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeValueOrFn = exports.CustoComponent = void 0;
const react_1 = __importDefault(require("react"));
const html_1 = require("../utils/html");
const flags_1 = require("../flags");
const objects_1 = require("../utils/objects");
const set_1 = require("../utils/set");
const react_sanitize_dom_props_1 = require("react-sanitize-dom-props");
class CustoComponent {
    /* eslint-enable */
    constructor(comp, defaultProps, additionalOptions) {
        this.$$end$$ = true;
        /* eslint-disable */
        this.outerBeforeComponents = [];
        this.outerAfterComponents = [];
        this.outerWrapperComponents = [];
        this.outermostWrapperComponents = [];
        this.innerStartComponents = [];
        this.innerEndComponents = [];
        this.innerWrapperComponents = [];
        this.transformProps = (props) => props;
        this.component = comp;
        this.defaultProps = defaultProps || {};
        additionalOptions = additionalOptions || {};
        if (additionalOptions.outerBeforeComponents) {
            this.outerBeforeComponents = toArray(additionalOptions.outerBeforeComponents);
        }
        if (additionalOptions.outerAfterComponents) {
            this.outerAfterComponents = toArray(additionalOptions.outerAfterComponents);
        }
        if (additionalOptions.outerWrapperComponents) {
            this.outerWrapperComponents = toArray(additionalOptions.outerWrapperComponents);
        }
        if (additionalOptions.outermostWrapperComponents) {
            this.outermostWrapperComponents = toArray(additionalOptions.outermostWrapperComponents);
        }
        if (additionalOptions.innerStartComponents) {
            this.innerStartComponents = toArray(additionalOptions.innerStartComponents);
        }
        if (additionalOptions.innerEndComponents) {
            this.innerEndComponents = toArray(additionalOptions.innerEndComponents);
        }
        if (additionalOptions.innerWrapperComponents) {
            this.innerWrapperComponents = toArray(additionalOptions.innerWrapperComponents);
        }
        if (additionalOptions.transformProps) {
            this.transformProps = additionalOptions.transformProps;
        }
        this.name = additionalOptions.name;
        this.mergeStartegy = additionalOptions.mergeStartegy;
        this.propsMergeStrategy = additionalOptions.propsMergeStrategy;
        this.propsToDefaultPropsMergeStrategy = additionalOptions.propsToDefaultPropsMergeStrategy;
        this.avoidAnyMerging = !!additionalOptions.avoidAnyMerging;
        this.avoidLinkageMerging = !!additionalOptions.avoidLinkageMerging;
        this.avoidMergingDifferentComponents = !!additionalOptions.avoidMergingDifferentComponents;
        this.labels = additionalOptions.labels
            ? new Set(additionalOptions.labels)
            : new Set();
        this.stripPropKeys = additionalOptions.stripPropKeys;
        this.additionalMergeFlags = additionalOptions.additionalMergeFlags;
        this.subtractiveMergeFlags = additionalOptions.subtractiveMergeFlags;
        this.avoidStrippingInvalidDOMProps = !!additionalOptions.avoidStrippingInvalidDOMProps;
    }
    render(props) {
        const _a = this.getMergedProps(props), { children: initialChildren } = _a, mergedProps = __rest(_a, ["children"]);
        const ref = props.ref;
        let finalProps = this.transformProps(objects_1.removeKeys(mergedProps, ...(this.stripPropKeys || [])));
        if (typeof this.component === "string" &&
            !this.avoidStrippingInvalidDOMProps) {
            finalProps = react_sanitize_dom_props_1.pickHTMLProps(finalProps, false);
        }
        let children = Array.isArray(initialChildren)
            ? initialChildren
            : initialChildren === undefined
                ? []
                : [initialChildren];
        if (this.innerStartComponents.length ||
            this.innerEndComponents.length) {
            children = this.innerStartComponents
                .map(renderMap)
                .concat(children)
                .concat(this.innerEndComponents.map(renderMap));
        }
        let inner = children;
        if (this.innerWrapperComponents.length > 0) {
            let innerComp = react_1.default.createElement(react_1.default.Fragment, {}, ...inner);
            innerComp = wrapInComps(innerComp, ...this.innerWrapperComponents);
            inner = [innerComp];
        }
        let mainElement = react_1.default.createElement(this.component, Object.assign(Object.assign({}, finalProps), { ref }), // TODO: get ref from finalProps before pickHTMLProps
        ...children);
        if (this.outerWrapperComponents.length > 0) {
            mainElement = wrapInComps(mainElement, ...this.outerWrapperComponents);
        }
        if (this.outerBeforeComponents.length === 0 &&
            this.outerAfterComponents.length === 0 &&
            this.outermostWrapperComponents.length === 0) {
            return mainElement;
        }
        const children2 = react_1.default.createElement(react_1.default.Fragment, {}, this.outerBeforeComponents.map(renderMap), mainElement, this.outerAfterComponents.map(renderMap));
        if (this.outermostWrapperComponents.length === 0) {
            return children2;
        }
        else {
            return wrapInComps(children2, ...this.outermostWrapperComponents);
        }
    }
    mergeClass(cl, mergeFlags) {
        try {
            if (cl === this)
                return this;
            const mergeFlagsSet = mergeFlags
                ? new Set(mergeFlags)
                : new Set();
            if (this.additionalMergeFlags) {
                set_1.unionWith.call(mergeFlagsSet, this.additionalMergeFlags);
            }
            if (this.subtractiveMergeFlags) {
                set_1.subtractSet.call(mergeFlagsSet, this.subtractiveMergeFlags);
            }
            if (!(cl instanceof CustoComponent))
                return this;
            else if (this.mergeStartegy) {
                return this.mergeStartegy(this, cl, mergeFlagsSet);
            }
            const component = this.component === null || this.component === undefined
                ? cl.component
                : this.component;
            if (this.avoidAnyMerging || cl.avoidAnyMerging) {
                return this;
            }
            if (mergeFlagsSet.has(flags_1.CustoMergeFlagEnum.avoidWithPackageDefaultValue) &&
                (this.labels.has(flags_1.CustomizableLabels.packageDefaultValue) ||
                    cl.labels.has(flags_1.CustomizableLabels.packageDefaultValue))) {
                return this;
            }
            if (mergeFlagsSet.has(flags_1.CustoMergeFlagEnum.avoidWithNonPackageValue) &&
                (!this.labels.has(flags_1.CustomizableLabels.packageDefaultValue) ||
                    !cl.labels.has(flags_1.CustomizableLabels.packageDefaultValue))) {
                return this;
            }
            if (mergeFlagsSet.has(flags_1.CustoMergeFlagEnum.linking) &&
                mergeFlagsSet.has(flags_1.CustoMergeFlagEnum.avoidLinking)) {
                return this;
            }
            if ((this.avoidMergingDifferentComponents ||
                cl.avoidMergingDifferentComponents) &&
                component !== cl.component) {
                return this;
            }
            if ((this.avoidLinkageMerging || cl.avoidLinkageMerging) &&
                mergeFlagsSet.has(flags_1.CustoMergeFlagEnum.linking)) {
                return this;
            }
            if (this.propsMergeStrategy) {
                const propsMergeStrategy = this.propsMergeStrategy;
                const normalizedPropsMergeStrategy = (currentComponentProps, secondaryComponentProps) => propsMergeStrategy(currentComponentProps, secondaryComponentProps, mergeFlagsSet);
                const mergedProps = exports.mergeValueOrFn(this.defaultProps, cl.defaultProps, normalizedPropsMergeStrategy);
                return new CustoComponent(component, mergedProps, this.getCopiedAdditionalOptions());
            }
            if (typeof component === "string" &&
                typeof cl.component === "string") {
                const mergedProps = exports.mergeValueOrFn(this.defaultProps, cl.defaultProps, html_1.deepMergeHTMLProps);
                return new CustoComponent(component, mergedProps, this.getCopiedAdditionalOptions());
            }
            if (component !== this.component) {
                return new CustoComponent(component, this.defaultProps, this.getCopiedAdditionalOptions());
            }
            return this;
        }
        catch (e) {
            return this;
        }
    }
    getMergedProps(props) {
        const defaultProps = typeof this.defaultProps === "function"
            ? this.defaultProps(props)
            : this.defaultProps;
        if (this.propsToDefaultPropsMergeStrategy) {
            return this.propsToDefaultPropsMergeStrategy(props, defaultProps);
        }
        return Object.assign(Object.assign({}, defaultProps), props);
    }
    /** Returns new Customized Component and adds new component to it */
    addComponent(place, 
    /** single or array of customized components */
    component, 
    /** circular index */
    index) {
        const cloned = this.clone();
        const array = cloned.getComponentsArr(place);
        index = typeof index === "number" ? index : -1;
        index = getCirculatedIndex(index, array.length + 1);
        array.splice(index, 0, ...toArray(component));
        return cloned;
    }
    getComponentsArr(place) {
        if (place === "innerEnd") {
            return this.innerEndComponents;
        }
        if (place === "innerStart") {
            return this.innerStartComponents;
        }
        if (place === "innerWrapper") {
            return this.innerWrapperComponents;
        }
        if (place === "outerAfter") {
            return this.outerAfterComponents;
        }
        if (place === "outerBefore") {
            return this.outerBeforeComponents;
        }
        if (place === "outerWrapper") {
            return this.outerWrapperComponents;
        }
        if (place === "outermostWrapper") {
            return this.outermostWrapperComponents;
        }
        throw new Error("incorrect place " + place);
    }
    clone() {
        return new CustoComponent(this.component, this.defaultProps, this.getCopiedAdditionalOptions());
    }
    getCopiedAdditionalOptions() {
        return {
            outerAfterComponents: [...this.outerAfterComponents],
            outerBeforeComponents: [...this.outerBeforeComponents],
            outerWrapperComponents: [...this.outerWrapperComponents],
            outermostWrapperComponents: [...this.outermostWrapperComponents],
            innerEndComponents: [...this.innerEndComponents],
            innerStartComponents: [...this.innerStartComponents],
            innerWrapperComponents: [...this.innerWrapperComponents],
            avoidMergingDifferentComponents: this
                .avoidMergingDifferentComponents,
            mergeStartegy: this.mergeStartegy,
            labels: new Set(this.labels),
            avoidAnyMerging: this.avoidAnyMerging,
            avoidLinkageMerging: this.avoidLinkageMerging,
            propsMergeStrategy: this.propsMergeStrategy,
            name: this.name,
            transformProps: this.transformProps,
            stripPropKeys: this.stripPropKeys,
            additionalMergeFlags: this.additionalMergeFlags,
            subtractiveMergeFlags: this.subtractiveMergeFlags,
            avoidStrippingInvalidDOMProps: this.avoidStrippingInvalidDOMProps,
        };
    }
    static create(comp, defaultProps, additionalOptions) {
        return new CustoComponent(comp, defaultProps, additionalOptions);
    }
}
exports.CustoComponent = CustoComponent;
const toArray = (el) => {
    if (Array.isArray(el))
        return el;
    return [el];
};
exports.mergeValueOrFn = (v1, v2, mergeFn) => {
    if (typeof v1 !== "function" && typeof v2 !== "function") {
        return mergeFn(v1, v2);
    }
    return ((...args) => {
        const val1 = typeof v1 === "function"
            ? v1(...args)
            : v1;
        const val2 = typeof v2 === "function"
            ? v2(...args)
            : v2;
        return mergeFn(val1, val2);
    });
};
const getCirculatedIndex = (index, length) => {
    if (index >= 0 && index < length)
        return index;
    if (length <= 0)
        return 0;
    if (index > 0) {
        return index % length;
    }
    index = ((index % length) + length) % length;
    return index;
};
const renderMap = (e, i) => {
    return e.render({ key: i });
};
const wrapInComps = (comp, ...wrappers) => {
    let result = comp;
    for (let i = wrappers.length - 1; i >= 0; i--) {
        const wrapper = wrappers[i];
        result = wrapper.render({ children: result });
    }
    return result;
};
